import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ADMISSIONS_ERROR, CREATE_ADMISSION, CREATING_ADMISSION, GETTING_ADMISSIONS, GET_ADMISSIONS, UPDATE_ADMISSION, UPDATING_ADMISSION } from "../types"


export const createAdmission = (admissionPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_ADMISSION,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/admissions`, admissionPayload, { headers })
        
        dispatch({
            type: CREATE_ADMISSION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: ADMISSIONS_ERROR,
            error
        })
    }
}

export const updateAdmission = (admissionId, admissionPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_ADMISSION,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/admissions/${admissionId}`, admissionPayload, { headers })
        
        dispatch({
            type: UPDATE_ADMISSION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: ADMISSIONS_ERROR,
            error
        })
    }
}

export const fetchAdmissions = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/admissions?expand=academicSession,fee`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ADMISSIONS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_ADMISSIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ADMISSIONS_ERROR,
            error
        })
    }
}

export const clearCreatedAdmission = () => async (dispatch) => {    
    dispatch({
        type: CREATE_ADMISSION,
        payload: null
    })
}

export const clearUpdatedAdmission = () => async (dispatch) => {    
    dispatch({
        type: UPDATING_ADMISSION,
        payload: null
    })
}
